<template>
  <div class="app-container">
    <div
      ref="filterContainer"
      class="filter-container"
    >
      <!-- 后退、前进、设置列 -->
      <table-operation
        :init-table-column="masterList.initTableColumn"
        :table-columns.sync="masterList.tableColumns"
        :table-key="masterList.tableKey"
        :table-index.sync="masterList.tableIndex"
        :search-condition.sync="masterList.tableQuery"
        :table-transfer-name="getTransferName()"
        @reloadData="requestData()"
      />
    </div>
    <div class="container-box">
      <!-- 查询条件 -->
      <div ref="searchCondition">
        <el-row :gutter="10">
          <el-col style="width:40px;padding-left:10px;">
            <el-button
              type="text"
              style=""
            >
              查询：
            </el-button>
          </el-col>
          <el-col :span="3">
            <el-input
              v-model="masterList.tableQuery.search.storeName"
              placeholder="请输入店名"
              style="width:100%"
              clearable
              @keyup.enter.native="searchData()"
            />
          </el-col>
          <el-col :span="3">
            <el-input
              v-model="masterList.tableQuery.search.certificateNo"
              placeholder="请输入专卖证号"
              style="width:100%"
              clearable
              @keyup.enter.native="searchData()"
            />
          </el-col>
          <el-col :span="3">
            <el-input
              v-model="masterList.tableQuery.search.materialsName"
              placeholder="请输入物料名称"
              style="width:100%"
              clearable
              @keyup.enter.native="searchData()"
            />
          </el-col>
          <el-col :span="3">
            <el-input
              v-model="masterList.tableQuery.search.manageUserName"
              placeholder="请输入维护人"
              style="width:100%"
              clearable
              @keyup.enter.native="searchData()"
            />
          </el-col>
          <el-col :span="3">
            <date-select :search-date.sync="masterList.tableQuery.search.searchDate" />
          </el-col>
          <el-col
            :xs="12"
            :sm="8"
            :md="6"
            :lg="4"
            :xl="3"
          >
            <el-button
              type="primary"
              @click="searchData()"
            >
              搜索
            </el-button>
          </el-col>
        </el-row>
      </div>
      <!-- 数据列表 -->
      <custom-table
        :ref="masterList.tableKey"
        style="margin-top:5px"
        :data-obj="masterList"
        :table-key="masterList.tableKey"
        :table-columns="masterList.tableColumns"
        :table-data="masterList.tableData"
        :loading="masterList.tableLoading"
        :search-condition.sync="masterList.tableQuery"
        :data-total="masterList.tableDataTotal"
        :table-contextmenu="masterList.tableContextmenu"
        :table-custom-height="tableHeight"
        is-index-field
        is-paging
        @reloadData="loadTableData()"
        @export="batchExport(masterList)"
      />
    </div>
  </div>
</template>

<script>
// Table操作组件（后退、前进、列设置）
import TableOperation from '@/components/TableOperation'
// 列表设置tableKeyMixin
import tableOperationMixin from '@/mixin/tableOperationMixin'
// 自定义Table
import CustomTable from '@/components/CustomTable'
// 导出 batchExportMixin
import batchExportMixin from '@/mixin/batchExportMixin'
// 定义表头颜色，高度，搜索，获取数据Mixin
import tableCustomMixin from '@/mixin/tableCustomMixin'
// 日期选择
import DateSelect from '@/components/DateSelect'
// 数据请求
import { loadStoreVisitMaterialsDetailListDataApi, loadStoreVisitMaterialsDetailExportDataApi } from '@/api/storeVisitReport'
export default {
  name: 'StoreVisitMaterialsDetail',
  components: {
    CustomTable,
    TableOperation,
    DateSelect
  },
  mixins: [tableCustomMixin, tableOperationMixin, batchExportMixin],
  data () {
    return {
      // 主列表
      masterList: {
        initTableColumn: [], // Table初始化列
        tableColumns: [], // Table列
        tableKey: 'store_visit_materials_detail_master', // Table Key
        tableIndex: 0, // Table Index
        tableLoading: true, // Table加载状态
        tableData: [], // Table数据
        tableDataTotal: 0, // Table总数据条数
        // Table右键
        tableContextmenu: [
          {
            permissionSigns: ['store_visit_materials_detail_export'],
            prop: 'export',
            label: '导出',
            method: 'export'
          }
        ],
        tableQuery: {
          page: 1, // 页数
          limit: 50, // 每页条数
          contextmenuWrap: [], // 右键筛选字段
          // 排序对象
          sort: {
            prop: 'tsvr.visit_date', // 排序字段
            order: 'desc' // 排序类型 asc升序 desc降序
          },
          // 查询条件
          search: {
            storeName: '',
            certificateNo: '',
            materialsName: '',
            manageUserName: '',
            searchDate: 'month',
          }
        }
      },
      id: null, // 选中的单据ID
    }
  },
  created () {
    // 初始化主列表Table列
    this.masterList.initTableColumn = [
      { prop: 'rowNumber', label: '序号', width: 80 },
      { prop: 'storeName', label: '零售户', filterColumn: 's.store_name', width: 100 },
      { prop: 'certificateNo', label: '专卖证号', filterColumn: 's.certificate_no', width: 120 },
      { prop: 'manageUserName', label: '维护人', filterColumn: 's.manage_user_name', width: 100 },
      { prop: 'visitDateStr', label: '拜访日期', filterColumn: 'tsvr.visit_date', width: 110, isBetween: true },
      { prop: 'visitUserName', label: '拜访人', filterColumn: 'tsvr.visit_user_name', width: 110 },
      { prop: 'outdepot_id', label: '出库单编号', filterColumn: 'd.outdepot_id', width: 120 },
      { prop: 'schemeName', label: '方案名称', filterColumn: 'bill.scheme_name', width: 200 },
      { prop: 'schemeNo', label: '方案编号', filterColumn: 'bill.scheme_no', width: 150 },
      { prop: 'materialsName', label: '物料名称', filterColumn: 'bill.materials_name', width: 120 },
      { prop: 'sourceTypeStr', label: '物料来源', filterColumn: '(case bill.source_type when 1 then "自制" when 2 then "中心配送" else "" end)', width: 120 },
      { prop: 'unitName', label: '物料单位', filterColumn: 'bill.unit_name', width: 110 },
      { prop: 'price', label: '单价', filterColumn: 'bill.price', width: 80, isBetween: true },
      { prop: 'amount', label: '数量', filterColumn: 'bill.amount', width: 80, isBetween: true },
      { prop: 'usedMethod', label: '用途', filterColumn: 'bill.used_method', width: 100 },
      { prop: 'operatorName', label: '操作人', filterColumn: 'tsvr.operator_name', width: 100 },
      { prop: 'operationTimeStr', label: '操作时间', filterColumn: 'tsvr.operation_time', width: 160, isBetween: true }
    ]
    // 默认主列表Table列
    this.getInitTableColumns()
    this.loadTableData()
  },
  methods: {
    // 请求数据
    requestData () {
      this.masterList.tableLoading = true
      let pageCondition = { condition: JSON.stringify(this.masterList.tableQuery) }
      loadStoreVisitMaterialsDetailListDataApi(pageCondition).then(response => {
        this.masterList.tableLoading = false
        let data = response.data.data ? response.data.data : []
        this.handleData(data)
        this.masterList.tableDataTotal = response.data.recordsTotal
      }).catch()
    },
    // 查询
    searchData () {
      // 重置右键筛选条件
      this.masterList.tableQuery.page = 1
      this.masterList.tableQuery.contextmenuWrap = []
      // 重置排序条件
      this.masterList.tableQuery.sort.prop = 'tsvr.visit_date'
      this.masterList.tableQuery.sort.order = 'desc'
      this.loadTableData()
    },
    // 导出数据API
    ExportByPage () {
      let pageCondition = { condition: JSON.stringify(this.exportObj) }
      loadStoreVisitMaterialsDetailExportDataApi(pageCondition).then(res => {
        let exportObj = { exportSuccess: true, url: res.data }
        this.$store.dispatch('message/settingExportSuccess', exportObj)
      })
    }
  }
}
</script>
